
document.addEventListener("mouseup", (e) => {
    if (e.target.closest(".product-bundle-discount")) {
        e.target.closest(".product-bundle-discount").classList.add("active");
        Array.from(document.querySelectorAll(".product-bundle-discount")).forEach(el => {
            if (el !== e.target.closest(".product-bundle-discount") || e.target.closest(".bundle-discount-tooltip svg") ) {
                el.classList.remove("active");
            }
        })
    }
})